/// <amd-module name="Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedArtifactsResources" />
import { ConsumedArtifactSource} from "Build/Client/Contracts/DataProvider";
import { IVssComponentProperties } from "VSS/Platform/Layout";

export interface IConsumedArtifactsCardProps extends IVssComponentProperties {
    consumedSource: ConsumedArtifactSource;
    buildId: number;
}

export namespace ConsumedArtifactTypes {
    export const Pipeline = "Pipeline";
    export const TfsVersionControl = "TfsVersionControl";
    export const Git = "Git";
    export const TfsGit = "TfsGit";
    export const GitHub = "GitHub";
    export const GitHubEnterprise = "GitHubEnterprise";
    export const Bitbucket = "Bitbucket";
    export const Svn = "Svn";
    export const DockerHub = "DockerHub";
    export const AzureContainerRepository = "AzureContainerRepository";
}

export namespace ArtifactCategory {
    export const PipelineArtifactCategory = "pipeline";
    export const ContainerArtifactCategory = "container";
    export const RepositoryArtifactCategory = "repository";
}

export namespace ConsumedArtifactPropertyKeys {
    export const ProjectId = "projectId";
    export const ContainerImageUri = "ContainerUri";
}